<template>
  <div class="page">
    <h5 class="text-center">
      Te damos la bienvenida al formulario que te permitirá informarnos una situación de alerta.
    </h5>
    <p class="text-muted text-center">
      Por favor comunícanos la situación de alerta que se está presentando en tu barrio o vereda,
      para que el Sistema de Alertas Tempranas de Medellín (SATMED) pueda orientarte adecuadamente
      respecto a las acciones que debes realizar para su superación.
    </p>
    <div class="text-center h4 satmed-dot-tittle">
      <b>¿A nombre de quién quieres alertar?</b>
    </div>
    <div class="satmed-card">
      <div class="d-flex justify-content-center align-items-start flex-wrap">
        <div>
          <b-button
            pill
            id="btn-alert-in-own-name"
            @click="
              a.A_NOM_DE = 0;
              changePage(page + 1);
            "
            :class="[a.A_NOM_DE === 0 ? 'satmed-btn-primary' : 'satmed-btn-outline-primary']"
            class="mx-3 my-3 py-2"
          >
            A NOMBRE PROPIO
          </b-button>
          <b-tooltip
            target="btn-alert-in-own-name"
            triggers="hover"
            placement="bottom"
            custom-class="satmed-help-tooltip in-own-name-tooltip"
            :fallback-placement="['bottom']"
          >
            Si usted está en riesgo
          </b-tooltip>
        </div>
        <div>
          <b-button
            pill
            id="btn-alert-by-another"
            @click="a.A_NOM_DE = 1"
            :class="[a.A_NOM_DE === 1 ? 'satmed-btn-primary' : 'satmed-btn-outline-tertiary']"
            class="mx-3 my-3 py-2"
          >
            POR OTRA PERSONA
          </b-button>
          <b-tooltip
            target="btn-alert-by-another"
            triggers="hover"
            placement="bottom"
            custom-class="satmed-help-tooltip by-another-tooltip"
            :fallback-placement="['bottom']"
            ref="tooltip"
          >
            Indique si usted es:
            <div class="select-informant-type">
              <b-button-group vertical>
                <template v-for="(informantType, index) of listQuienInforma">
                  <b-button
                    v-if="!informantType.disabled"
                    :key="index"
                    @click="setInformantType(informantType.value)"
                    variant="light"
                  >
                    {{ informantType.text }}
                  </b-button>
                </template>
              </b-button-group>
            </div>
          </b-tooltip>
          <div class="mt-3" v-if="a.A_NOM_DE === 1">
            <b-form-group
              v-if="a.QUIEN_INFORMA === 'Funcionario de otra entidad'"
              label="Nombre de la entidad"
              label-for="CUAL_ENTIDAD"
              class="mx-2"
            >
              <b-form-input v-model="a.ENTIDAD_FUNCIONARIO" id="CUAL_ENTIDAD"></b-form-input>
            </b-form-group>
            <b-form-group
              v-if="a.QUIEN_INFORMA === 'Funcionario de la alcaldía'"
              label="Nombre del funcionario"
              label-for="CUAL_FUNCIONARIO"
              class="mx-2"
            >
              <b-input v-model="a.NOMBRE_FUNCIONARIO" id="CUAL_FUNCIONARIO"></b-input>
            </b-form-group>
            <div class="text-right">
              <b-button
                pill
                @click="changePage(2)"
                :disabled="!validatePage()"
                class="satmed-btn-tertiary"
              >
                CONTINUAR
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <p class="text-center text-tip mt-3">
        Si tienes dudas para diligenciar el formulario, visita nuestra sección pedagógica haciendo
        <a
          href="https://www.youtube.com/watch?v=jB05jrf9U0E"
          target="_blank"
        >
          click aquí
        </a>
      </p>
    </div>
    <div>
      <p class="text-center text-tip mt-3">
        <b>
          Consulta el estado de tu alerta haciendo
          <a
            href="/satmed/consultar-caso"
          >
            click aquí
          </a>
        </b>
      </p>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';

const listQuienInforma = [
  { text: 'Seleccionar...', value: null, disabled: true },
  { text: 'Ciudadano', value: 'Ciudadano' },
  { text: 'Funcionario de la alcaldía', value: 'Funcionario de la alcaldía' },
  { text: 'Funcionario de otra entidad', value: 'Funcionario de otra entidad' },
];

export default {
  name: 'PaginaNombreDe',
  props: {
    page: Number,
  },
  data() {
    return {
      listQuienInforma,
    };
  },
  computed: {
    ...mapState({
      a: (state) => state.alerta.item,
      pageValidate: (state) => state.alerta.pageValidate,
      funcionarios: (state) => state.alerta.funcionarios,
    }),
  },
  methods: {
    ...mapMutations('alerta', ['changePage']),
    validatePage() {
      if (this.a.A_NOM_DE === 0) {
        this.a.QUIEN_INFORMA = null;
      }
      if (this.a.QUIEN_INFORMA !== 'Funcionario de otra entidad') {
        this.a.CUAL_ENTIDAD = null;
      }
      if (this.a.QUIEN_INFORMA !== 'Funcionario de la alcaldía') {
        this.a.FUNCIONARIO_ID = null;
      }

      if (this.a.A_NOM_DE === 0) {
        return true;
      }

      if (this.a.A_NOM_DE === 1) {
        if (this.a.QUIEN_INFORMA === 'Ciudadano') {
          return true;
        }
        if (this.a.QUIEN_INFORMA === 'Funcionario de otra entidad' && this.a.ENTIDAD_FUNCIONARIO) {
          return true;
        }
        if (this.a.QUIEN_INFORMA === 'Funcionario de la alcaldía' && this.a.NOMBRE_FUNCIONARIO) {
          return true;
        }
      }
      return false;
    },
    setInformantType(informantType) {
      this.a.A_NOM_DE = 1;
      this.a.QUIEN_INFORMA = informantType;
      this.$refs.tooltip.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
div.page {
  max-width: 1448px;
  margin: auto;
  h5 {
    font-size: 24px;
  }
  p {
    font-size: 24px;

    &.text-muted {
      font-size: 20px;
    }

    &.text-tip {
      font-size: 18px;
      margin: 0px 5px;
    }
  }
}

@media screen and (max-width: 992px) {
  div.page {
    h5 {
      font-size: 18px;
    }
    p {
      font-size: 16px;

      &.text-muted {
        font-size: 16px;
      }

      &.text-tip {
        font-size: 16px;
        margin-top: 5px;
      }
    }
  }

  .satmed-dot-tittle {
    font-size: 20px;
  }
}

.satmed-card {
  max-width: 913px;
  margin: auto;
}

.satmed-btn-primary {
  height: 76px;
  width: 286px;
}
</style>

<style lang="scss">
.satmed-help-tooltip {
  &.tooltip {
    opacity: 1;
  }

  .arrow::before {
    bottom: -5px;
    border-width: 14px 0.4rem 0;
  }

  &.in-own-name-tooltip {
    .arrow::before {
      border-top-color: #8b7acd;
    }
  }

  &.by-another-tooltip {
    .arrow::before {
      border-top-color: #bc86d0;
    }
  }

  .tooltip-inner {
    background: none;
    max-width: 320px;
    color: black;
  }

  .select-informant-type {
    box-shadow: 0px 10px 30px #00000029;
    border-radius: 10px;
    overflow: hidden;
    .btn.btn-light {
      font: normal normal normal 16px/16px Montserrat;
      height: 50px;
      text-align: left;
      padding-left: 29px;
      padding-right: 29px;
      &:hover {
        background: #bc86d0;
        color: white;
      }
    }
  }
}
</style>
